<template>
    <div>
        <!-- Multi select access point groups table -->
       
                <v-card v-if="multi" flat>
                           
                <v-toolbar flat class="primary">
                    <h1 class="headline white--text">SEARCH ACCESS POINT GROUPS</h1>
                </v-toolbar>
                <v-card-text>
                 <v-container grid-list-xs>
                    <v-layout wrap>
                        <v-text-field v-model="search2"
                                      append-icon="search"
                                      label="Search"
                                      single-line
                                      hide-details
                                      max-width="50px"
                                      class="pa-3"
                                      clearable></v-text-field>
                    </v-layout>
                    <v-data-table v-model="selected"
                                  :headers="headers2"
                                  :items="accessPointGroups"
                                  :pagination.sync="pagination"
                                  select-all
                                  :search="search2"
                                  item-key="id"
                                  class="elevation-1">
                        <template v-slot:headers="props">
                            <tr>
                                <th>
                                    <v-checkbox :input-value="props.all"
                                                :indeterminate="props.indeterminate"
                                                primary
                                                hide-details
                                                @click.stop="toggleAll"></v-checkbox>
                                </th>
                                <th v-for="header in props.headers"
                                    :key="header.text"
                                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)">
                                    <v-icon small>arrow_upward</v-icon>
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :active="props.item.flag" @click="clearAndSetMultiFlags(props.item.id)">
                                <td>
                                    <v-checkbox :input-value="props.item.flag"
                                                primary
                                                hide-details></v-checkbox>
                                </td>
                                <td class="text-xs-center">{{props.item.name}}</td>
                                <td class="text-xs-center">{{props.item.description}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn color="primary" round @click="onSelection()">Cancel</v-btn>
                          <v-btn color="primary" round @click="onSelection()">Done</v-btn>
                    </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>

               <!-- Single select access point groups table -->
       
                       <v-card v-if="!multi" flat>
                           
                <v-toolbar flat class="primary">
                    <h1 class="headline white--text">SEARCH ACCESS POINT GROUPS</h1>
                </v-toolbar>
                <v-card-text>
                 <v-container grid-list-xs>
                    <v-layout wrap>
                        <v-text-field v-model="search2"
                                      append-icon="search"
                                      label="Search"
                                      single-line
                                      hide-details
                                      max-width="50px"
                                      class="pa-3"
                                      clearable></v-text-field>
                    </v-layout>
                    <v-data-table v-model="selected"
                                  :headers="headers2"
                                  :items="accessPointGroups"
                                  :pagination.sync="pagination"
                                  select-all
                                  :search="search2"
                                  item-key="id"
                                  class="elevation-1">
                        <template v-slot:headers="props">
                            <tr>
                                <th>
                        
                                </th>
                                <th v-for="header in props.headers"
                                    :key="header.text"
                                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)">
                                    <v-icon small>arrow_upward</v-icon>
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :active="props.item.flag" @click="clearAndSetFlags(props.item.id)">
                                <td>
                                    <v-checkbox :input-value="props.item.flag"
                                                primary
                                                hide-details></v-checkbox>
                                </td>
                                <td class="text-xs-center">{{props.item.name}}</td>
                                <td class="text-xs-center">{{props.item.description}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn color="primary" round @click="onSelection()">Cancel</v-btn>
                          <v-btn color="primary" round @click="onSelection()">Done</v-btn>
                    </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
         </div>
</template>
<!--////////////////////////////////////////////////////////////////////-->
<script>
    import Api from "@/services/Api";
    import format from "date-fns/format";

    export default {
        components: {
        },
        props: [ "accesspointgroupsearchmodal", "multi", "preselected"
               ],
        data: function () {
            return {
                multi: true,
                accessPointGroups: [],
                selected: [],
                pagination: {},
                headers2: [
                    {
                        text: "Name",
                        align: "center",
                        value: "name"
                    },
                    {
                        text: "Description",
                        align: "center",
                        value: "description"
                    }
                ],
                search2: '',
            };
        },
        created() {
            this.initialize();
        },
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////
        methods: {
            initialize() {
               this.fetchAccessPointGroups();
               this.selected= this.preselected            
               
            },
            onSelection(){
                let proceed =true
                if(this.selected.length==0){
                     this.$emit('accessPointGroupSelected', this.selected=[])  
                }if (proceed == true) {
                    this.$emit('accessPointGroupSelected', this.selected)  
                }
            },
            clearAndSetFlags(id) { 
                for(let i=0;i<this.accessPointGroups.length;i++) {
                    this.accessPointGroups[i].flag = false;
                    if(this.accessPointGroups[i].id == id) {
                        this.accessPointGroups[i].flag = true;
                        this.selected = [];
                        this.selected.push(this.accessPointGroups[i])
                    }
                }
            },
            clearAndSetMultiFlags(id) {
                for(let i=0;i<this.accessPointGroups.length;i++) {
                    if(this.accessPointGroups[i].id == id) {
                        if(this.accessPointGroups[i].flag) {
                            for(let k=0;k<this.selected.length;k++) {
                                if(this.selected[k].id == this.accessPointGroups[i].id) {
                                     this.selected.splice(k, 1);
                                     break;
                                }
                            }  
                            this.accessPointGroups[i].flag = false;
                        }
                        else {
                            this.selected.push(this.accessPointGroups[i])
                            this.accessPointGroups[i].flag = true;
                        }
                    }
                }

            },
             toggleAll() {
                if (this.selected.length) this.selected = []
                else this.selected = this.accessPointGroups.slice()
            },
            randomMethod() {
                if(!this.multi) {
                    for(let i=0; i<this.accessPointGroups.length; i++){
                        this.accessPointGroups[i].flag = false;
                        if(typeof(this.selected[0]) != 'undefined'){
                            if(this.accessPointGroups[i].id == this.selected[0].id){
                                this.accessPointGroups[i].flag = true;
                            }
                        }
                    }
                }  
                else {
                    for(let i=0; i<this.accessPointGroups.length; i++){
                        this.accessPointGroups[i].flag = false;
                        for(let j=0; j<this.selected.length; j++) {
                            if(typeof(this.selected[j]) != 'undefined'){
                                if(this.accessPointGroups[i].id == this.selected[j].id) {
                                    this.accessPointGroups[i].flag = true;
                                }
                            }       
                        }
                    }
                }
            },
            changeSort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column
                    this.pagination.descending = false
                }
            },
            fetchAccessPointGroups(){
            Api()
             .get('/accessPointGroups/getAllGroupsOnMainPage')
             .then(response=>{
              this.accessPointGroups=response.data      
               this.randomMethod();     
              });
            },         
        }
    };
</script>
<style>

</style>
